export var LoginStatus;
(function (LoginStatus) {
    LoginStatus["NORMAL"] = "normal";
    LoginStatus["FORBID"] = "forbidden";
})(LoginStatus || (LoginStatus = {}));
//# sourceMappingURL=LoginStatus.js.map